import { isMobile } from "../common/utils";
import algoliasearch from "algoliasearch";
import { format as formatDate } from "date-fns";

const client = algoliasearch("ZGISPFZEQK", "0127e1a89a00ce11a21a8a03c69e5ae9");
const entries = client.initIndex("entries");

const initializeBrandArticles = (el, brandName) => {
  el.style.display = "none";
  getBrandArticles(el, brandName);
};

const getBrandArticles = (el, brandName) => {
  if (brandName == "JOHN MASON SMITH / JANE SMITH") {
    entries
      .search("", {
        filters: `blog.id:21 AND (brands.name:'JOHN MASON SMITH' OR brands.name:'JANE SMITH')`,
      })
      .then(({ hits }) => {
        if (hits && 0 < hits.length) {
          renderArticle(el, hits[0]);
        }
        getPersonArticles(el, brandName);
      });
  } else {
    entries
      .search("", {
        filters: `blog.id:21 AND brands.name:'${brandName.replace("'", "\\'")}'`,
      })
      .then(({ hits }) => {
        if (hits && 0 < hits.length) {
          renderArticle(el, hits[0]);
        }
        getPersonArticles(el, brandName);
      });
  }
};

const getPersonArticles = (el, brandName) => {
  if (brandName == "JOHN MASON SMITH / JANE SMITH") {
    entries
      .search("", {
        filters: `blog.id:23 AND (brands.name:'JOHN MASON SMITH' OR brands.name:'JANE SMITH')`,
      })
      .then(({ hits }) => {
        if (hits && 0 < hits.length) {
          hits.slice(0, 2).map((h) => renderArticle(el, h));
        }
      });
  } else {
    entries
      .search("", {
        filters: `blog.id:23 AND brands.name:'${brandName.replace("'", "\\'")}'`,
      })
      .then(({ hits }) => {
        if (hits && 0 < hits.length) {
          renderArticle(el, hits[0]);
        }
      });
  }
};

const renderArticle = (el, article) => {
  const dateStr = formatDate(new Date(article.date * 1000), "yyyy.MM.dd");

  el.style.display = "block";
  const articlesEl = el.querySelector(".fs-articles");
  const articleEl = document.createElement("article");
  articleEl.classList.add("fs-article");
  articleEl.innerHTML = `
    <a href="https://www.fashionsnap.com${article.permalink}" target="_blank">
      <div class="fs-article-content">
        <div class="fs-image">
          <img src="${article.thumbnail.normal}" alt="">
        </div>
        <div class="fs-texts">
          <p class="fs-label">関連記事</p>
          <h4 class="article-title">${article.title}</h4>
          <p>${article.excerpt}</p>
          <p class="fs-tags">
            <a href="https://www.fashionsnap.com/brand-person/" target="_blank" class="fs-category-label">ブランド・ヒト</a>
            <span>${article.blog.name === "パーソン" ? "ヒト" : "ブランド"}</span>
          </p>
          <p class="fs-date">${dateStr}</p>
        </div>
      </div>
    </a>
  `;
  articlesEl.append(articleEl);
};

export default {
  initializeBrandArticles: initializeBrandArticles,
};
